import React, { useState } from "react";
import { ReactComponent as RaceSportIcon } from '../../assets/race-flag.svg';
import { getUrlToFetch } from '../../data/utils/getUrlToFetch';
import { getAccountIds } from '../../data/utils/getAccountIds';
import { getConfiguration } from '../../data/utils/configuration';
import { useFetch } from "../../data/fetch/useFetch";
import { systemCode, urls } from "../..";
import { getLabel } from "../../data/labels";
import { LinkToRaceSportPage, resolveRaceSportPageUrlCustom } from "./RaceSportButtonScroller";


export default function RaceSportButton(props) {
    const conf = getConfiguration();
    const xrc = conf.xrc ?? { enabled: true, url: "/XRaces/infoSport" };
    const [isRaceActive,setIsRaceActive] = useState(false);
    const numConto = getAccountIds()?.split(";")?.[1] || '';
    let hrefLinkXSport =  `${urls.base}/${urls?.['race-sport']?.['race-sport']}` || '/race-sport'; //pathname configurato lato sportbook
    const hrefLinkXCasino = typeof window.cg_SEO_URL_MAPPING_REVERSE != 'undefined' ?  JSON.parse(window.cg_SEO_URL_MAPPING_REVERSE)?.['xcasinoracesport']: null; //pathname configurato lato contogioco
    

    if (xrc?.customUrl) {
        hrefLinkXSport = resolveRaceSportPageUrlCustom(xrc.customUrl);
    }

    const [isLoading, isError, data] = useFetch(getUrlToFetch(conf.xrc?.url), {
        system_code: systemCode,
        num_conto: numConto,
        skipBaseParams: true
    }, (data) =>{
        try {
            if(parseInt(data?.raceAttiva) > 0 && !isRaceActive){
                setIsRaceActive(true);
            }
        }catch(err) {
            if(isRaceActive) {
                setIsRaceActive(false);
            }
            console.error(err);
        }
    },
    conf.xrc?.enabled? true: false  
    );

    return (isRaceActive &&
        <>
            <LinkToRaceSportPage hrefLinkXCasino={hrefLinkXCasino} hrefLinkXSport={hrefLinkXSport} className={`xsport-race-sport-icon-container shrink-0 h-[50px] grid grid-cols-12 items-center border-y border-y-cs7`}>
                <div className="xsport-race-sport-icon xs-sport-icon col-start-1 col-end-3 justify-self-center inline-block w-[24px] h-[24px]">
                    <RaceSportIcon />
                </div>
                <div className="col-start-3 col-end-11 font-medium text-sm text-cs-3">{getLabel('race_sport.title', 'Race Sport')}</div>
            </LinkToRaceSportPage>
        </>
    )
}